var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoDocumento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1963 8.38836H4.80365V10.0785H17.1963V8.38836Z",
    fill: "#093C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1963 11.8882H4.80365V13.5783H17.1963V11.8882Z",
    fill: "#093C5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1963 15.3883H4.80365V17.0785H17.1963V15.3883Z",
    fill: "#093C5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5822 5.51684V5.51456L15.8171 0.903198H2.75934C1.39837 0.903198 0.295166 1.87657 0.295166 3.07696V20.4906C0.295166 21.691 1.39837 22.6643 2.75934 22.6643H12.2284V20.4906H2.75934V3.07696H13.9026V7.48332H19.2406V18.6501H19.2501V22.6643C20.6065 22.6598 21.7048 21.6883 21.7048 20.4906V6.60372L20.5822 5.51684Z",
    fill: "#093C5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1901 23.3222H18.0387V19.7009C18.0382 19.509 17.9617 19.325 17.826 19.1893C17.6902 19.0536 17.5063 18.9771 17.3143 18.9766H14.4166C14.2252 18.9779 14.042 19.0547 13.907 19.1904C13.7719 19.326 13.6958 19.5095 13.6953 19.7009V23.3222H12.5416C11.8963 23.3222 11.5713 24.1043 12.0276 24.5606L15.3517 27.885C15.4187 27.9521 15.4982 28.0054 15.5859 28.0418C15.6735 28.0781 15.7674 28.0968 15.8623 28.0968C15.9571 28.0968 16.051 28.0781 16.1387 28.0418C16.2263 28.0054 16.3059 27.9521 16.3729 27.885L19.6973 24.5602C20.1536 24.1046 19.8347 23.3222 19.1901 23.3222Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDocumento);
export default __webpack_public_path__ + "static/media/icono_documento.a7b9fe0e458444b84b8f676a5f62a26a.svg";
export { ForwardRef as ReactComponent };